__turbopack_context__.v({
  "inner": "tg8SnW_inner",
  "label": "tg8SnW_label",
  "loader": "tg8SnW_loader",
  "root": "tg8SnW_root",
  "section": "tg8SnW_section",
});
